/** @typedef {'dev' | 'sandbox' | 'prod'} AppEnvironmentTier */

export const APP_ENVIRONMENTS = Object.freeze(['dev', 'sandbox', 'prod']);

export const ENV_BANNER_HEIGHT_PX = 28;

const APP_ENV_ALIASES = {
  dev: 'dev',
  development: 'dev',
  sandbox: 'sandbox',
  test: 'sandbox',
  staging: 'sandbox',
  prod: 'prod',
  production: 'prod',
};

const TEST_API_HOST_MARKERS = ['diamonduptest', 'sandbox', '-test.'];

/**
 * @param {string | undefined | null} value
 * @returns {AppEnvironmentTier | null}
 */
export function normalizeAppEnvironment(value) {
  if (value == null || value === '') return null;
  const key = String(value).trim().toLowerCase();
  return APP_ENV_ALIASES[key] ?? null;
}

/**
 * Resolve tier from CRA build-time variables (before API confirmation).
 * @returns {AppEnvironmentTier}
 */
export function resolveEnvironmentFromBuild() {
  const fromBuild = normalizeAppEnvironment(process.env.REACT_APP_BUILD_ENV);
  if (fromBuild) return fromBuild;

  if (process.env.NODE_ENV === 'development') return 'dev';
  if (process.env.NODE_ENV === 'test') return 'sandbox';

  const api = (process.env.REACT_APP_API_URL || '').toLowerCase();
  if (TEST_API_HOST_MARKERS.some((marker) => api.includes(marker))) return 'sandbox';
  if (api.includes('localhost') || api.includes('127.0.0.1')) return 'dev';

  return 'prod';
}

/**
 * @param {AppEnvironmentTier | null | undefined} tier
 * @returns {boolean}
 */
export function shouldShowEnvironmentBanner(tier) {
  return tier === 'dev' || tier === 'sandbox';
}
